export const resolveAuthContinuePath = (continuePath?: string | null) => {
  if (!continuePath || !continuePath.startsWith("/") || continuePath.startsWith("//")) {
    return "/"
  }

  return continuePath
}

export const buildAuthContinueUrl = (continuePath?: string | null) => {
  const resolvedPath = resolveAuthContinuePath(continuePath)
  const baseUrl = new URL(import.meta.env.BASE_URL, window.location.origin).toString()
  const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`
  const relativePath = resolvedPath === "/" ? "" : resolvedPath.slice(1)

  return new URL(relativePath, normalizedBaseUrl).toString()
}
